import i18n from '@/plugins/i18n';

const attributes = {
  water: {
    links: [
      {
        attribute: 'diameter',
        element_type: 'attribute_holder',
        isConstant: true,
        unit: 'mm',
        dataType: {
          name: 'float',
        },
      },
      {
        attribute: 'material',
        element_type: 'attribute_holder',
        isConstant: true,
        dataType: {
          name: 'text',
        },
      },
      {
        attribute: 'length',
        element_type: 'attribute_holder',
        unit: 'm',
        isConstant: true,
        dataType: {
          name: 'float',
        },
      },
      {
        attribute: 'flow',
        element_type: 'attribute_holder',
        unit: 'm3/h',
        isConstant: false,
        dataType: {
          name: 'float',
        },
      },
      {
        attribute: 'velocity',
        element_type: 'attribute_holder',
        unit: 'm/s',
        isConstant: false,
        dataType: {
          name: 'float',
        },
      },
      {
        attribute: 'headloss',
        element_type: 'attribute_holder',
        unit: 'm H2O',
        isConstant: false,
        dataType: {
          name: 'float',
        },
      },
      {
        attribute: 'reversed_direction',
        element_type: 'attribute_holder',
        trueText: i18n.t('inputs.reverseDirection'),
        falseText: i18n.t('inputs.direction'),
        isConstant: false,
        dataType: {
          name: 'boolean',
        },
        valueQuery: '{flow} < 0',
        isValueQueryEval: true,
      },
    ],
    nodes: [
      {
        attribute: 'elevation',
        element_type: 'attribute_holder',
        isConstant: true,
        unit: 'm.n.p.m.',
        dataType: {
          name: 'float',
        },
      },
      {
        attribute: 'pressure',
        element_type: 'attribute_holder',
        isConstant: false,
        unit: 'MPa',
        dataType: {
          name: 'float',
        },
      },
      {
        attribute: 'age',
        element_type: 'attribute_holder',
        isConstant: false,
        unit: 'h',
        dataType: {
          name: 'float',
        },
      },
      {
        attribute: 'hydraulic_grade',
        element_type: 'attribute_holder',
        isConstant: false,
        unit: 'm n.p.m.',
        dataType: {
          name: 'float',
        },
      },
    ],
  },
  sewer: {
    links: [
      {
        attribute: 'flow',
        element_type: 'attribute_holder',
        isConstant: false,
        unit: 'l/s',
        dataType: {
          name: 'float',
        },
      },
      {
        attribute: 'velocity',
        element_type: 'attribute_holder',
        isConstant: false,
        unit: 'm/s',
        dataType: {
          name: 'float',
        },
      },
      {
        attribute: 'depth',
        element_type: 'attribute_holder',
        isConstant: false,
        unit: 'cm',
        dataType: {
          name: 'float',
        },
      },
      {
        attribute: 'diameter',
        element_type: 'attribute_holder',
        isConstant: true,
        unit: 'mm',
        dataType: {
          name: 'float',
        },
      },
      {
        attribute: 'bottom_elevation_start',
        element_type: 'attribute_holder',
        isConstant: true,
        unit: 'm',
        dataType: {
          name: 'float',
        },
      },
      {
        attribute: 'bottom_elevation_end',
        element_type: 'attribute_holder',
        isConstant: true,
        unit: 'm',
        dataType: {
          name: 'float',
        },
      },
      {
        attribute: 'slope',
        element_type: 'attribute_holder',
        isConstant: true,
        unit: '%',
        dataType: {
          name: 'float',
        },
      },
      {
        attribute: 'reversed_direction',
        element_type: 'attribute_holder',
        trueText: i18n.t('inputs.reverseDirection'),
        falseText: i18n.t('inputs.direction'),
        isConstant: false,
        dataType: {
          name: 'boolean',
        },
        valueQuery: '0',
        isValueQueryEval: true,
      },
    ],
    nodes: [
      {
        attribute: 'flow',
        element_type: 'attribute_holder',
        isConstant: false,
        unit: 'l/s',
        dataType: {
          name: 'float',
        },
      },
      {
        attribute: 'depth',
        element_type: 'attribute_holder',
        isConstant: false,
        unit: 'cm',
        dataType: {
          name: 'float',
        },
      },
      {
        attribute: 'diameter',
        element_type: 'attribute_holder',
        isConstant: true,
        unit: 'mm',
        dataType: {
          name: 'float',
        },
      },
      {
        attribute: 'elevation_top',
        element_type: 'attribute_holder',
        isConstant: true,
        unit: 'm',
        dataType: {
          name: 'float',
        },
      },
      {
        attribute: 'elevation_bottom',
        element_type: 'attribute_holder',
        isConstant: true,
        unit: 'm',
        dataType: {
          name: 'float',
        },
      },
    ],
  },
};

const ranges = {
  water: {
    nodes: {
      pressure: {
        name: 'pressure',
        unit: 'MPa',
        ranges: [0.2, 0.3, 0.4, 0.5, 0.6],
      },
      hydraulic_grade: {
        name: 'hydraulic_grade',
        unit: 'm n.p.m.',
        ranges: [187, 213, 230, 242, 250],
      },
    },
    links: {
      headloss: {
        name: 'headloss',
        unit: 'm H2O',
        ranges: [0.2, 0.3, 0.4, 0.5, 0.6],
      },
      velocity: {
        name: 'velocity',
        unit: 'm/s',
        ranges: [0.05, 0.1, 0.2, 0.5, 1],
      },
      flow: {
        name: 'flow',
        unit: 'm3/h',
        ranges: [0.1, 0.5, 1, 2, 3],
        abs: true,
      },
    },
  },
  sewer: {
    nodes: {
      flow: {
        name: 'flow',
        unit: 'l/s',
        ranges: [3, 3.2, 3.4, 3.5, 3.7],
      },
      depth: {
        name: 'depth',
        unit: 'cm',
        ranges: [0.2, 0.3, 0.4, 0.5, 0.6],
      },
    },
    links: {
      flow: {
        name: 'flow',
        unit: 'l/s',
        ranges: [3, 3.2, 3.4, 3.5, 3.7],
      },
      depth: {
        name: 'depth',
        unit: 'cm',
        ranges: [0.2, 0.3, 0.4, 0.5, 0.6],
      },
      velocity: {
        name: 'velocity',
        unit: 'm/s',
        ranges: [0.05, 0.1, 0.2, 0.5, 1],
      },
    },
  },
};

const colors = {
  0: '#0000ff',
  1: '#00ffff',
  2: '#00ff00',
  3: '#ffff00',
  4: '#f90',
  5: '#f00',
};

const labelsColors = {
  0: '#ffffff',
  1: '#3f3e3e',
  2: '#3f3e3e',
  3: '#3f3e3e',
  4: '#ffffff',
  5: '#ffffff',
};

export { attributes, colors, labelsColors, ranges };
